export default __webpack_public_path__ + "static/media/model3.093472a5.png";